import { render, staticRenderFns } from "./IncludedFiltersIcon.vue?vue&type=template&id=879c1bac&scoped=true"
import script from "./IncludedFiltersIcon.vue?vue&type=script&lang=js"
export * from "./IncludedFiltersIcon.vue?vue&type=script&lang=js"
import style0 from "./IncludedFiltersIcon.vue?vue&type=style&index=0&id=879c1bac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "879c1bac",
  null
  
)

export default component.exports